module.exports = require("core-js/modules/es.array.index-of.js");